/**
 * Same-origin API base when REACT_APP_BACKEND_URL is empty (nginx / CRA proxy, P3).
 */
export function apiOrigin() {
  return (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
}

export function apiV1() {
  return `${apiOrigin()}/api/v1`;
}

/** Absolute or same-origin URL for backend-served assets (logos, uploads). */
export function assetUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${apiOrigin()}${path.startsWith('/') ? path : `/${path}`}`;
}

export function tenantHeaders(extra = {}) {
  const h = { ...extra };
  const tid = localStorage.getItem('active_tenant_id');
  if (tid) h['X-Tenant-ID'] = tid;
  return h;
}
